import styled from '@emotion/styled';
import { Input } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { Topics } from 'src/modules/programs/components/Topics';
import { color, font } from 'src/shared/styles/variables';

import { Answer, OptionsQuestion } from '../models/weekFour';
import { getPracticeSelectedAnswerByQuestionId } from '../selectors/weekFourSelectors';

const QuestionWrapper = styled('div')({
    paddingLeft: '1.5rem',
    position: 'relative',
    marginBottom: '3rem',
    '&:last-child': {
        marginBottom: '2rem',
    },
    '&:before': {
        position: 'absolute',
        content: '""',
        width: '0.5rem',
        height: '0.5rem',
        backgroundColor: color.scooter,
        borderRadius: 2,
        left: '0.25rem',
        top: '0.4rem',
    },
});

const QuestionText = styled('p')(
    {
        color: color.tundora,
        maxWidth: '50rem',
    },
    font.book(font.size.medium),
);

const StyledInput = styled<any>(Input)({
    marginTop: '1rem',
    maxWidth: '52rem',
});

interface StateProps {
    selectedAnswer: Answer | undefined;
}

interface Props extends StateProps {
    question: OptionsQuestion;
    handleAnswerChange: (topic: string, field: string, id: number) => void;
    handleInputChange: (id: number) => void;
}

const PracticeQuestionHolderContainer: React.SFC<Props> = ({
    handleAnswerChange,
    handleInputChange,
    question,
    selectedAnswer,
}) => {
    return (
        <QuestionWrapper>
            <QuestionText>{question.text}</QuestionText>
            <Topics
                topics={question.answers.map(answer => answer.description)}
                selectedTopics={selectedAnswer ? [selectedAnswer.description] : undefined}
                onTopicChange={description =>
                    handleAnswerChange(description, 'answer', question.id)
                }
            />
            {selectedAnswer && selectedAnswer.description === 'Other' && (
                <StyledInput
                    value={selectedAnswer.additionalAnswer}
                    onChange={handleInputChange(question.id)}
                    size="large"
                    placeholder="E.g. it feels it would be hard to do"
                />
            )}
        </QuestionWrapper>
    );
};

const mapStateToProps = (state: AppState, { question }: Props): StateProps => ({
    selectedAnswer: getPracticeSelectedAnswerByQuestionId(state, question.id),
});

export const PracticeQuestionHolder = connect<StateProps>(
    mapStateToProps,
    {},
)(PracticeQuestionHolderContainer);
